/**
 * Redux Store Configuration
 * Central store setup with middleware and reducers
 */

import { configureStore } from '@reduxjs/toolkit';
import companiesReducer from './slices/companiesSlice';
import authReducer from './slices/authSlice';
import plansReducer from './slices/plansSlice';
import staffReducer from './slices/staffSlice';
import jobsReducer from './slices/jobsSlice';
import ticketsReducer from './slices/ticketsSlice';
import companyUsersReducer from './slices/companyUsersSlice';
import candidatesReducer from './slices/candidatesSlice';
import candidateLinksReducer from './slices/candidateLinksSlice';
import jobListingsReducer from './slices/jobListingsSlice';
import jobFavoritesReducer from './slices/jobFavoritesSlice';
import jobFairReducer from './slices/jobFairSlice';
import systemLogsReducer from './slices/systemLogsSlice';

/**
 * Configure and create Redux store
 */
export const store = configureStore({
  reducer: {
    companies: companiesReducer,
    auth: authReducer,
    plans: plansReducer,
    staff: staffReducer,
    jobs: jobsReducer,
    tickets: ticketsReducer,
    companyUsers: companyUsersReducer,
    candidates: candidatesReducer,
    candidateLinks: candidateLinksReducer,
    jobListings: jobListingsReducer,
    jobFavorites: jobFavoritesReducer,
    jobFair: jobFairReducer,
    systemLogs: systemLogsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
  devTools: import.meta.env.DEV, // Enable Redux DevTools in development
});

// Type definitions for TypeScript (if needed in the future)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
